function BlogsCount(props) {
    let count;
    if (props && props.count) {
        count = props.count;
    } else {
        count = 0;
    }

    return (
        <div className="blog-count">
            {count > 0 ? (count >= 100 ? '100+' : count) : ''}
        </div>
    )
}

export default BlogsCount;